var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProposalIconSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.554,
    height: 33.149,
    viewBox: "0 0 15.554 33.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22951",
    "data-name": "Path 22951",
    d: "M.183,25.808c0,.022.055.183.077.321l.277.8a7.618,7.618,0,0,0,7.243,4.923h.031A7.9,7.9,0,0,0,10.5,31.38a7.45,7.45,0,0,0,4.693-9.236C13.585,17.891,2.427,10.659.068,7.366c.824,6.018-.382,14.968.06,18.143",
    transform: "translate(-0.027 -7.366)",
    fill: "#e64ddf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22956",
    "data-name": "Path 22956",
    d: "M.165,24.306c0,.02.048.168.069.295l.245.732a6.762,6.762,0,0,0,6.413,4.522h.027a6.766,6.766,0,0,0,2.377-.43,6.918,6.918,0,0,0,4.155-8.484C12.032,17.033,2.152,10.391.063,7.366c.73,5.528-.338,13.749.053,16.666",
    transform: "translate(-0.027 -7.366)",
    fill: "#63abe2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6203",
    "data-name": "Group 6203",
    transform: "translate(0 4.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6180",
    "data-name": "Group 6180",
    transform: "translate(0.024 4.234)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22950",
    "data-name": "Path 22950",
    d: "M21.466,10.611,9.162,39.193-9.583,20.248,2.721-8.334Z",
    transform: "translate(2.023 -3.188)",
    fill: "#e64ddf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6205",
    "data-name": "Group 6205",
    transform: "translate(0.383 6.228)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22955",
    "data-name": "Path 22955",
    d: "M17.908,9.068,7.014,35.322l-16.6-17.4L1.311-8.334Z",
    transform: "translate(2.889 -2.25)",
    fill: "#3d0a46",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6202",
    "data-name": "Group 6202",
    transform: "translate(0 -4.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22949",
    "data-name": "Path 22949",
    d: "M9.657,0A4.955,4.955,0,1,1,4.7,4.955,4.954,4.954,0,0,1,9.657,0",
    transform: "translate(-1.88)",
    fill: "#472e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22952",
    "data-name": "Path 22952",
    d: "M16.336,25.831c.223-3.589-.857-12.449-.033-18.466C13.943,10.659,2.785,17.89,1.18,22.144a7.451,7.451,0,0,0,4.693,9.235c4.464,1.621,9.5-1.23,10.3-4.462l.11-.674a4.03,4.03,0,0,0,.049-.412",
    transform: "translate(-0.812 1.302)",
    fill: "#419ad5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22954",
    "data-name": "Path 22954",
    d: "M15.072,23.8c.2-3.194-.787-11.08-.03-16.436C12.874,10.3,2.625,16.733,1.15,20.519a6.576,6.576,0,0,0,4.311,8.219c4.1,1.443,8.728-1.095,9.465-3.971l.1-.6a3.48,3.48,0,0,0,.045-.366",
    transform: "translate(0.108 3.994)",
    fill: "rgba(46,56,77,0.47)",
    opacity: 0.23
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposalIconSmall);
export default __webpack_public_path__ + "static/media/proposal-icon-small.e69f25458765bbaa3a3cc714057626b2.svg";
export { ForwardRef as ReactComponent };